export const sortByLabel = (
  countryList: { value: string; label: string; icon: string }[],
  locale?: string
) => {
  const collator = createCollator(locale)
  return [...countryList].sort((a, b) => collator.compare(a.label ?? '', b.label ?? ''))
}

function createCollator(locale?: string): Intl.Collator {
  const options: Intl.CollatorOptions = { sensitivity: 'base' }
  try {
    return new Intl.Collator(locale || undefined, options)
  } catch {
    return new Intl.Collator(undefined, options)
  }
}
